module.exports = __webpack_public_path__ + "img/asfores.79d62601.jpg";